import React from 'react'
import styles from './CreditCardForm.scss'
import moment from 'moment'
import { FormattedMessage as T } from 'react-intl'

export const CreditCardForm = () => {
  return (
    <div className={styles.CreditCardForm}>
      <span className={styles.ccNumberLabel}>
        <label htmlFor={'cardNumber'}><T id='CreditCardForm.ccNumber' defaultMessage='Credit Card Number' /></label>
        <img className={styles.cards} src={'/images/revised_layout/cards.png'} />
      </span>
      <input
        type='text'
        id='cardNumber'
        name='cardNumber'
        data-braintree-name='number' />
      <label htmlFor={'expires'}><T id='CreditCardForm.expires' defaultMessage='Expires' /></label>
      <span className={styles.monthYear}>
        <select
          id='month'
          name='month'
          data-braintree-name='expiration_month'
          className={styles.month}>
          {moment.months().map((m, idx) => (<option key={idx} value={`${idx + 1}`}>{m} ({idx + 1})</option>))}
        </select>
        <select
          id='year'
          name='year'
          data-braintree-name='expiration_year'
          className={styles.year}>
          {Array(15).fill().map((_, idx) => (<option key={idx} value={moment().year() + idx}>{moment().year() + idx}</option>))}
        </select>
      </span>
    </div>
  )
}
